exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment-container[data-v-3ead4fa7]{border-radius:10px;border:1px solid rgba(0,0,0,.38);padding:20px}", ""]);

// exports
